import React from "react";
import { Routes, Route } from "react-router-dom";
import { Navigate } from "react-router";
import { OnboardingContactDetails } from "./onboarding-contact-details";
import { OnboardingQualifyingQuestions } from "./onboarding-qualifying-questions";
import { OnboardingPrimaryEducationDetails } from "./onboarding-primary-education-details";
import { OnboardingPassportDetails } from "./onboarding-passport-details";
import { OnboardingIdVerificationPreview } from "./onboarding-id-verification-preview";
import { OnboardingIdVerificationProcessPayment } from "./onboarding-id-verification-process-payment";

export const Onboarding: React.FC = () => { 
  return (
    <Routes>
      <Route index element={<Navigate to="qualifying-questions" replace />} />
      <Route path="qualifying-questions" element={<OnboardingQualifyingQuestions />} />
      <Route path="contact-details" element={<OnboardingContactDetails />} />
      <Route path="primary-education-details" element={<OnboardingPrimaryEducationDetails />} />
      <Route path="passport-details" element={<OnboardingPassportDetails />} />
      <Route path="id-verification-preview" element={<OnboardingIdVerificationPreview />} />
      <Route path="process-payment" element={<OnboardingIdVerificationProcessPayment />} />
    </Routes>
  );
}